import React, { useMemo } from 'react';
import CarReservListContainer from '../../containers/carmng/CarReservListContainer';


const CarReservListPage = () => {

  return (
     <CarReservListContainer />
  );
};

export default CarReservListPage;
